import { EuiButtonIcon, EuiCheckboxGroup, EuiFlexGrid, EuiFlexGroup, EuiFlexItem, EuiIcon, EuiLink, EuiPanel, EuiSwitch, EuiText, EuiTitle } from '@elastic/eui';
import React,{useEffect, useMemo,useState} from 'react';
import { getColumnas } from './constants';
import './styles.css';

export const ConfiguracionColumnasUsuarioScreen = (props:any) =>{

    const {data,onSave,user} = props
    const columnas = getColumnas(user);

    const [screenSelected, setScreenSelected] = useState<any>(undefined)
    const [columnsSelected, setColumnsSelected] = useState<any>({})
    const [all, setAll] = useState<boolean>(false);
    const [config,setConfig] = useState<any>(undefined)

    const onClearColumns = () =>{setColumnsSelected({});}

    useEffect(()=>{(config === undefined && data) && setConfig(JSON.parse(data))},[data])

    const chkColumns = useMemo(() =>{
        return screenSelected && screenSelected.columnas;
    },[screenSelected])

    const checkAll = () =>{
        let newChecksAll = {}
        chkColumns && chkColumns.forEach((d:any) => {
            newChecksAll = {...newChecksAll, ...{[d.id]:true}}
        })
        
        setColumnsSelected({...newChecksAll})
    }

    const getInitColumns = () =>{
        if(screenSelected && config!==undefined){
            const columns = config.pantallas.filter((f:any)=> f.pantalla === screenSelected.key)[0]
            const todas = columns!==undefined ? (Object.keys(Object.fromEntries(Object.entries(columns.columnas).filter(([key, val]) => val === false))).length === 0) : true
            let newChecks = {}
            newChecks = columns!==undefined ? {...newChecks, ...{...columns.columnas}} : newChecks
            setAll(todas)
            setColumnsSelected(newChecks)
        }else{
            screenSelected && checkAll()
        }
    }

    useEffect(()=>{
        getInitColumns();
    },[chkColumns,config])

    useEffect(()=>{
        if(all===true){
            checkAll()
        }else{
            onClearColumns()
        }
    },[all])

    const getListadoScreen = useMemo(() => {
        return columnas.filter((f:any)=> f.show===true).map((c:any) => {
            return (
                <EuiLink
                    className={`btn-list-user-permission ${screenSelected && c.title===screenSelected.title?'active':''}`}
                    onClick={() => setScreenSelected(c)}
                    >
                    <EuiFlexItem style={{fontSize:'1.5rem'}}>{`${c.title}`}</EuiFlexItem>
                </EuiLink>
            );
        });
    },[columnas,screenSelected])

    const titleSCreenSelected = useMemo(()=>{
    
        return screenSelected ? (<EuiFlexGroup gutterSize='none' alignItems='center' style={{height:'2em'}}>
          <EuiFlexItem grow={false} className='titleIconPermission titleUserIconPermission'>
            <EuiIcon type='fullScreen' size='m'/>
          </EuiFlexItem>
          <EuiFlexItem grow={false} className='titlePermission titleUserPermission'>
            <EuiTitle size='xs'>
              <h5>{`${screenSelected.title}`}</h5>
            </EuiTitle>
          </EuiFlexItem>
        </EuiFlexGroup>) : null
    
      },[screenSelected])

      const titleUser = useMemo(()=>{
    
        return (<EuiFlexGroup gutterSize='none' alignItems='center' style={{height:'2em'}}>
          <EuiFlexItem grow={false} className='titleIconPermission titleScreenIconConfigure'>
            <EuiIcon type='user' size='m'/>
          </EuiFlexItem>
          <EuiFlexItem grow={false} className='titlePermission titleScreenConfigure'>
            <EuiTitle size='xs'>
              <h5>{`${user.nombre}`}</h5>
            </EuiTitle>
          </EuiFlexItem>
        </EuiFlexGroup>)
    
      },[user])

    const onChangeColumn = (optionId:any) => {
        const newCheckboxIdToSelectedMap = {
            ...columnsSelected,
            ...{
            [optionId]: !columnsSelected[optionId],
            },
        };
        setColumnsSelected(newCheckboxIdToSelectedMap);
    };

    const filterObject = () => {
        return Object.keys(Object.fromEntries(Object.entries(columnsSelected).filter(([key, val]) => val === true)))
    }

    const getSeleccionados = useMemo(() =>{return filterObject().length},[columnsSelected])

    const onSaveConfig = () =>{
        let col = {}
        chkColumns.forEach((f:any)=> {col={...col,...{[f.id]:false}}})
        const screenConfig = {'pantalla':`${screenSelected.key}`,'columnas':{...col,...columnsSelected}}
        let newConfig=undefined
        if(config===undefined){
            newConfig ={
                pantallas:[screenConfig]
            }
        }else{
            const newPantallas = config.pantallas.filter((f:any)=> f.pantalla !== screenSelected.key)
            newPantallas.push(screenConfig)
            newConfig = {
                pantallas:newPantallas
            }
        }

        (onSave && newConfig) && onSave(JSON.stringify(newConfig))
    }

    const getColumnasSelected = () =>{
        return(
        <EuiFlexGroup direction='column' style={{height:'100%'}}>
            <EuiFlexItem grow={false}>
                <EuiFlexGroup alignItems='center' style={{borderBottom: '1px solid #d3dae6'}}>
                    <EuiFlexItem grow={false}>
                        <EuiSwitch
                        className='sw-dn-permissions'
                        label="Todas"
                        checked={all}
                        onChange={(e) => setAll(!all)}
                        />
                    </EuiFlexItem>
                    <EuiFlexItem grow={false} style={{padding:'0.5rem',background: '#f3f3f3'}}>
                        <EuiFlexGroup alignItems='center'>
                            <EuiFlexItem grow={false} style={{background: '#006bb4',padding: '0.2rem 0.5rem',color: 'white',borderRadius: '20px'}}>
                                <EuiText>{`${getSeleccionados} Columnas Seleccionadas`}</EuiText>
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                            <EuiButtonIcon style={{backgroundColor: '#f5d8d7',padding:'0.5rem',borderRadius: '30px'}} size='m' 
                            title='Limpiar Selección' iconType='refresh' color='danger' onClick={()=>setAll(false)}></EuiButtonIcon>
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                            <EuiButtonIcon style={{backgroundColor: '#c7e1f3',padding:'0.5rem',borderRadius: '30px'}} size='m' 
                            title='Guardar' iconType='save' color='primary' onClick={()=> onSaveConfig()}></EuiButtonIcon>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                    </EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiFlexGrid gutterSize='m' columns={3} direction="column">
                    <EuiCheckboxGroup
                        options={chkColumns}
                        idToSelectedMap={columnsSelected}
                        onChange={(id) => onChangeColumn(id)}
                        disabled={false}
                    />
                </EuiFlexGrid>
            </EuiFlexItem>
        </EuiFlexGroup>
        );
    }

    return (
    <EuiFlexGroup style={{height:'100%'}} gutterSize='l'>
        <EuiFlexItem grow={1} >
            <EuiText style={{ border: '1px solid #454a54',background: '#25282f',color: 'white',fontSize: '1.5rem',textAlign: 'center',padding: '0.2rem'}}>
                {'Pantallas'}
            </EuiText>
            <EuiPanel style={{height:'100%',borderRadius:'0px'}}>
                <EuiFlexGroup direction='column' style={{height:'100%'}}>
                {getListadoScreen}
                </EuiFlexGroup>
            </EuiPanel>
        </EuiFlexItem>

        <EuiFlexItem grow={9}>
            <EuiPanel style={{height:'100%',borderRadius:'0px'}}>
                <EuiFlexGroup direction='column' style={{height:'100%'}}>
                    {screenSelected ?
                    <>
                        <EuiFlexItem grow={false}>
                            <EuiFlexGroup alignItems={'center'} justifyContent="flexStart" className="filter" wrap>
                                <EuiFlexItem grow={false}>
                                    {titleUser}
                                </EuiFlexItem>
                                <EuiFlexItem grow={false}>
                                    {titleSCreenSelected}
                                </EuiFlexItem>
                            </EuiFlexGroup>
                        </EuiFlexItem>

                        <EuiFlexItem>
                            <EuiFlexGroup gutterSize='none'>
                            <EuiFlexItem style={{height:'90%'}}>
                            <EuiPanel style={{height:'100%',borderRadius:'0px',borderLeft: 'none',borderRight: 'none',borderBottom: 'none',boxShadow: 'none'}}>
                                {getColumnasSelected()}
                            </EuiPanel>
                            </EuiFlexItem>
                            </EuiFlexGroup>
                        </EuiFlexItem>
                    </>
                    :null}
                </EuiFlexGroup>
            </EuiPanel>
        </EuiFlexItem>
    </EuiFlexGroup>
        
    );

}